import { faHomeAlt } from "@fortawesome/free-regular-svg-icons";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";


export const navigationData = [
    {
        title: 'Home',
        icon: faHomeAlt,
        path: '/',
        protected: false
    },
    {
        title: 'Catalog',
        icon: faLayerGroup,
        path: '/catalog',
        protected: false
    },
    {
        title: 'About',
        icon: faHomeAlt,
        path: '/about',
        protected: false
    },
    {
        title: 'Admin',
        icon: faHomeAlt,
        path: '/admin_auth',
        protected: false
    }
]